module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-25.e20563d7.png";